export enum PortfolioHistoryPnlResetEnum {
	PER_DAY = 'per_day',
	NO_RESET = 'no_reset',
}
